import React from 'react';
import loadable from '@loadable/component';

// Types
import { EmojiProps } from './types';

const Emoji = loadable(() => import('./Emoji'));

const WpEmojiPicker = ({ emoji, size }: EmojiProps) => {
  return <Emoji emoji={emoji} size={size} />;
};

export default WpEmojiPicker;
